import { useState } from 'react';

import { Button } from '@nesso/ui/primitives/button';
import { RadioGroup } from '@nesso/ui/primitives/radio-group';
import { RadioGroupItemField } from '@nesso/ui/primitives/radio-group-item-field';

import type { NotesSettingsValue } from '@/entities/practice-member-settings';
import { SettingsRow } from '@/shared/ui/settings/settings-row';

import { TEMPLATE_OPTIONS } from '../config/notes-settings-options';
import { useNotesSetting } from '../model/use-notes-setting';

const LABEL = 'Default template';

type Template = NotesSettingsValue['defaultNoteTemplate'];

export function NoteTemplateInput() {
    const { value, save } = useNotesSetting('defaultNoteTemplate');
    const [selected, setSelected] = useState<Template | null>(null);

    const stopEditing = () => setSelected(null);

    const handleSave = () => {
        if (selected !== null && selected !== value) {
            save(selected);
        }
        stopEditing();
    };

    if (selected !== null) {
        return (
            <SettingsRow
                label={LABEL}
                caption={
                    <>
                        Need help choosing?{' '}
                        <Button
                            type="button"
                            variant="link"
                            size="sm"
                            className="h-auto p-0 text-sm text-muted-foreground underline decoration-solid decoration-from-font underline-offset-auto [text-underline-position:from-font]"
                        >
                            Learn more
                        </Button>
                    </>
                }
                action={{ label: 'Cancel', onClick: stopEditing }}
            >
                <RadioGroup value={selected} onValueChange={setSelected} aria-label={LABEL}>
                    {TEMPLATE_OPTIONS.map((option) => (
                        <RadioGroupItemField
                            key={option.value}
                            value={option.value}
                            label={option.label}
                        />
                    ))}
                </RadioGroup>
                <div>
                    <Button type="button" size="lg" onClick={handleSave}>
                        Save
                    </Button>
                </div>
            </SettingsRow>
        );
    }

    const label = TEMPLATE_OPTIONS.find((option) => option.value === value)?.label;

    return (
        <SettingsRow
            label={LABEL}
            caption={label}
            action={{
                label: 'Edit',
                onClick: () => setSelected(value),
                ariaLabel: 'Edit default template',
            }}
        />
    );
}
